<template>
  <div class="card-margin">
    <div class="active-rules">
      <div class="rules-content">
        <div class="rules-left labelTitle">活动规则：</div>
        <div class="rules-right">
          <div v-for="(item, index) in activeRules" :key="index" :class="able ? 'rules-right-contant' : 'rules-right-contant rules-right-contantCheck'">
            <span>购买商品</span>
            <div class="rules-item">
              <div>{{specObj.conditionSpec}}满</div>
                <NumberInput
                  class="num-input"
                  type='ifNeedCheckAllNumber'
                  :ifNeedCheckAllNumber='true'
                  :frontDecimal='7'
                  :precision ='2'
                  :min='0.01'
                  v-model='activeRules[index].goodsNum'
                  size='default'
                  placeholder="请输入"
                  v-if="able"
                  @on-change='handlerChange(index)'
                ></NumberInput>
                <span class="num-sapn" v-else>{{activeRules[index].goodsNum}}</span>
              <span>件，</span>
            </div>
            <div class="rules-item">
              <lk-select
                v-model="activeRules[index].countRule"
                class="num-input"
                v-if="able"
                @on-change='handlerCountRule($event, index)'
              >
                <lk-option v-for="item in countRuleLists"
                :key="item.id"
                :value='item.id'>{{item.id === 1 ? `每${activeRules[index].goodsNum || 0 }件`: item.name }}</lk-option>
              </lk-select>
              <span class="rules-span" v-else>{{activeRules[index].countRule == 1 ? `每${activeRules[index].goodsNum || 0 }件` :countRuleList[activeRules[index].countRule-1].name}}</span>
            </div>
            <!-- 买折不显示 -->
            <div v-if="promoteType != 2" class="promoteType1">
              <span>促销商品</span>
              <div>{{specObj.promotionSpec}}</div>
              <div class="rules-item">
                <NumberInput
                  class="num-input"
                  type='ifNeedCheckAllNumber'
                  :ifNeedCheckAllNumber='true'
                  :frontDecimal='7'
                  :precision ='2'
                  :min='0.01'
                  placeholder="请输入"
                  size='default'
                  v-if="able"
                  v-model="activeRules[index].discountNum"
                ></NumberInput>
                <span class="num-sapn" v-else> {{activeRules[index].discountNum}}</span>
                件
              </div>
            </div>
            <div v-else class="promoteType1">
              <div class="rules-item">
                <lk-select v-model="activeRules[index].discountRule" class="activeSelect" v-if="able" @ @on-change='handlerDiscountRule($event, index)'>
                  <lk-option v-for="item in discountRuleList[`${activeRules[index].countRule}`]"
                  :key="item.id"
                  :value='item.id'>{{ item.name }}</lk-option>
                </lk-select>
                <span class="active-span" v-else>{{discountRuleList[`${activeRules[index].countRule}`][activeRules[index].discountRule - 1].name || ''}}</span>
              </div>
              <div class="rules-item">
                 <NumberInput
                  class="num-input"
                  type='ifNeedCheckAllNumber'
                  :ifNeedCheckAllNumber='true'
                  :frontDecimal='7'
                  :precision ="activeRules[index].discountRule == 1 ? 3 :2 "
                  :min='activeRules[index].discountRule == 3 ? 0 : 0.01'
                  :max="activeRules[index].discountRule == 3 ? 10 :100000000"
                  placeholder="请输入"
                  size='default'
                  v-if="able"
                  v-model="activeRules[index].discountNum"
                ></NumberInput>
                 <span class="num-sapn" v-else> {{activeRules[index].discountNum}}</span>
              </div>
              <span>{{unitList[activeRules[index].discountRule]}}</span>
            </div>
            <div v-show="activeRules[index].countRule != 2 && (able || activeRules[index].maxNum != 0 )" class="maxNumContent">
              <span>，最多不超过</span>
              <div class="rules-item">
                <NumberInput
                  class="num-input"
                  type='ifNeedCheckAllNumber'
                  :ifNeedCheckAllNumber='true'
                  :frontDecimal='7'
                  :precision ='2'
                  :min="0"
                  placeholder="请输入"
                  size='default'
                  v-if="able"
                  v-model="activeRules[index].maxNum"
                ></NumberInput>
                <span class="num-sapn" v-else>{{activeRules[index].maxNum}}</span>
                <span>{{promoteType == 2 ? unitList[activeRules[index].discountRule] : '件'}}</span>
              </div>
            </div>
            <lk-button
              class="deleteOne"
              type="error"
              size='small'
              ghost
              @click="deleteOne(index)"
              v-show="index !== 0 && able"
            >删除</lk-button>
          </div>
          <div class="addCon">
            <lk-button
              class="addOne"
              type="primary"
              size='small'
              ghost
              @click="addOne"
              :disabled='activeRules.length === 5'
              v-if="able"
            >新增</lk-button>
            <span> 注：销售时，订单商品如同时满足多个规则，只有促销商品数量最多的规则会生效</span>
          </div>
        </div>
      </div>
      <div class="rules-content">
        <div class="rules-left note">折扣说明：</div>
        <lk-input type="textarea" placeholder="请输入" v-model="note" @on-blur='handlerInput' v-if="able" :maxlength='199'></lk-input>
        <span class="rebateNote" v-else>{{rebateNote}}</span>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'addPromotionGoods',
  components: {
  },
  props: {
    activeRules: {
      type: Array,
      default: () => [],
    },
    promoteType: {
      type: [Number, String],
    },
    rebateNote: {
      type: String,
      default: '',
    },
    goodsFormalList: {
      type: Array,
      default: () => [],
    },
    goodsGiveList: {
      type: Array,
      default: () => [],
    },
    able: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop:'activeRules',
    event: 'change'
  },
  computed: {
    specObj() {
      const conditionSpec = this.goodsFormalList.length ? this.goodsFormalList[0].drugSerialCode : '';
      const promotionSpec = this.goodsGiveList.length ? this.goodsGiveList[0].drugSerialCode : '';
      const specs = {
        conditionSpec,
        promotionSpec,
      };
      return specs;
    },
    countRuleLists() {
      return this.promoteType != 2 ? this.countRuleList.filter(item => item.id != 3) : this.countRuleList;
    }
  },
  watch: {
    rebateNote: {
      handler() {
        this.note = this.rebateNote;
      }
    }
  },
  data() {
    return {
      note: '',
      unitList: {
        '1':'元',
        '2':'件',
        '3':'折',
      },
      countRuleList: [
        {
          id: 1,
          name: ''
        },
        {
          id: 2,
          name: '一次性'
        },
        {
          id: 3,
          name: '每1件'
        },
      ],
      discountRuleList: {
        "1": [
          {
            id: 1,
            name: '按固定金额减免'
          },
          {
            id: 2,
            name: '按商品单价减免'
          },
        ],
        "2": [
          {
            id: 1,
            name: '按固定金额减免',
          },
          {
            id: 2,
            name: '按商品单价减免',
          },
          {
            id: 3,
            name: '按比例打折',
          },
        ],
        "3": [
          {
            id: 1,
            name: '按固定金额减免'
          },
          {
            id: 2,
            name: '按商品单价减免'
          },
        ],
      }
    }
  },
  methods: {
    handlerDiscountRule(val,index) {
      this.$set(this.activeRules[index], 'discountNum', '');
    },
    handlerCountRule(val ,index) {
      if (val == 2 && this.activeRules[index].maxNum) {  // 当选为一次性时，去除maxNum
        this.activeRules[index].maxNum = null;
      }
      if (this.promoteType == 2 && this.activeRules[index].discountRule != 1) {  // 当选为一次性时，discountRule默认1（按固定金额减免）,
        this.activeRules[index].discountRule = 1;
      }
    },
    handlerChange(index) {
      const { countRule } = this.activeRules[index];
      if (countRule && countRule != 2) {
        this.activeRules[index].countRule = 2;
        this.handlerCountRule(2,index);
      }
    },
    handlerInput(e) {
      this.$emit('addRebateNote', e.target.value)
    },
    deleteOne(index) {
      this.activeRules.splice(index, 1);
    },
    addOne() {
      if (this.goodsFormalList.length === 0) {
        this.$Message.warning('无法新增，请添加一个条件商品');
        return;
      }
      if (this.goodsGiveList.length === 0 && this.promoteType != 2) {
        this.$Message.warning('无法新增，请添加一个促销商品');
        return;
      }
      this.activeRules.push(
        {
          countRule: 2,
          discountRule: this.promoteType == 1 ? 4 : 1,
        }
      );
    },
  },
  created() {
  },
  mounted() {
  },
};
</script>
<style lang="less" scoped>
.promoteType1 {
  display: flex;
  align-items: center;
}
.activeSelect {
  width: 120px;
  margin: 0 5px;
}
.note {
  padding-left: 8px;
}
</style>
